const themes = [
  { id: 1, color: '#20C34E' },
  { id: 2, color: '#605CA8' },
  { id: 3, color: '#DD4B39' },
  { id: 4, color: '#3C8DBC' },
  { id: 5, color: '#F39C12' },
];

export default themes;
